module.exports = __webpack_public_path__ + "static/media/image_3.43700d23.png";